module.exports = __webpack_public_path__ + "img/loading_heart_gift.9dbc7866.svg";